export default __webpack_public_path__ + "static/media/coinbase-logo.e5251cc4.png";